import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'tool-form-action-button',
  templateUrl: './tool-form-action-button.component.html',
  styleUrl: './tool-form-action-button.component.css',
  standalone: false,
})
export class ToolFormActionButtonComponent {
  @Input({ required: true }) text!: string;
  @Input() disabled: boolean = false;
  @Input() type: 'submit' | 'reset' | 'button' = 'submit';
  @Input() color: string = '';
  @Input() textColor: string = '';
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  public env = environment;

  handleAction() {
    this.onClick.emit();
  }
}
